module.exports = __webpack_public_path__ + "static/media/Caixa1.9e94ddee.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/RelCaixa/Caixa1.png
// module id = 2030
// module chunks = 0